import { useOutletContext } from 'react-router-dom';

import { RadioGroupHorizontal, RadioGroupVertical } from '@/components';
import { OutletContext } from '@/model';

import { Content } from '../content';

export const WomanType = () => {
	const { landerId, versionId }: OutletContext = useOutletContext();
	const womanType = Content[landerId][versionId]?.womanType;

	const Orientation =
		womanType?.orientation === 'horizontal'
			? RadioGroupHorizontal
			: RadioGroupVertical;

	return (
		<Orientation
			options={womanType?.options ?? []}
			name={womanType?.name ?? ''}
		/>
	);
};
